import { EformApiClient } from '@qcm/eforms-client'
import React from "react";
import { File as FileI } from "../../interfaces/File";
import { uploadMinDelay, removeFromArray } from "../../utils/utils";
import { Error } from "../../interfaces/ApiMessages";
import Uploads from "../../interfaces/Uploads";

interface Props {
  children: any;
  formRef: any;
}

export const uploadFile = (file: File) =>
  EformApiClient.submissionAttach.uploadFile({
    file,
    type: 'form'
  }).then(res => ({
    id: res.id,
    name: file.name,
    nameShort: res.file.name,
    publicId: res.publicId,
    size: res.file.size,
    hash: res.file.hash,
    extension: res.file.extension,
  }))

class FileUpload extends React.Component<Props> {
  state: Uploads = {};

  handleAddFiles = (id: string, files: FileI[]) => {
    if (this.state[id] && this.state[id].length) return; // do not start new uploading batch if some files still uploading
    this.setState({
      ...this.state,
      [id]: files.map((file: FileI) => file.name)
    });

    files.forEach((file: FileI) => {
      Promise.all([uploadFile(file as any), uploadMinDelay()])
        .then((results: any) => results.filter((res: any) => res)[0]) // filter out 'undefined' that comes from uploadMinDelay()
        .then((uploadedFile: FileI) => {
          this.handleSuccess(id, uploadedFile);
        })
        .catch(e => {
          this.handleError(id);
        });
    });
  };

  handleError = (id: string) => {
    this.cancelUploads(id);
  };

  cancelUploads = (id: string) => {
    this.setState({
      ...this.state,
      [id]: undefined
    });
    this.props.formRef.current.handleUploadDone(id, undefined, Error.upload);
  };

  removeUpload = (id: string, fileID: string) => {
    this.setState({
      ...this.state,
      [id]: removeFromArray(this.state[id], fileID)
    });
  };

  wasFileCancelled = (id: string, fileID: string) => {
    if (!this.state[id]) return true;
    return !this.state[id].includes(fileID);
  };

  handleSuccess = (id: string, file: FileI) => {
    if (this.wasFileCancelled(id, file.name)) return;
    this.removeUpload(id, file.name);
    this.props.formRef.current.handleUploadDone(id, file);
  };

  handleCancel = (id: string, fileID: string) => {
    this.removeUpload(id, fileID);
    this.props.formRef.current.handleUploadCancel(id, fileID);
  };

  render() {
    return this.props.children(
      this.handleAddFiles,
      this.handleCancel,
      this.state
    );
  }
}

export default FileUpload;
